export const Pointer = ({ color }) => {
	return (
		<div className="counterItem">
			<svg
				id="pointer"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 1200 1200"
			>
				<path
					style={{ fill: color }}
					d="M724.93,950c-6.31,0-12.48-3.12-16.12-8.83l-139.78-219.22-88.01,99.36c-4.86,5.49-12.43,7.71-19.49,5.71-7.06-2-12.34-7.87-13.6-15.09l-93.98-539.57c-1.32-7.57,2.03-15.2,8.5-19.35,6.46-4.14,14.8-4.02,21.13,.34l454.49,312.82c6.08,4.18,9.2,11.5,8.02,18.78-1.18,7.29-6.46,13.24-13.55,15.28l-131.84,38.02,139.67,219.02c2.72,4.27,3.63,9.44,2.54,14.39-1.09,4.94-4.11,9.25-8.37,11.97l-99.36,63.35c-3.18,2.03-6.73,3-10.24,3Zm-153.41-278.74c.5,0,1,.02,1.5,.06,5.97,.47,11.38,3.72,14.6,8.77l143.12,224.46,67.17-42.83-143.14-224.46c-3.23-5.08-3.89-11.38-1.76-17.01,2.13-5.63,6.79-9.93,12.57-11.59l117.59-33.91L399.36,310.57l79.38,455.75,78.5-88.62c3.63-4.11,8.85-6.43,14.29-6.43Z"
				/>
			</svg>
			<p style={{ color }}>Request a follow-up</p>
		</div>
	);
};
